import { isPlatformBrowser } from "@angular/common";
import { Component, Inject, Input, OnInit, PLATFORM_ID } from "@angular/core";
import { Platform } from "@ionic/angular";
import { AuthService } from "src/app/auth/auth.service";
import { ApiService } from "src/app/services/api.service";
import { UserInterface } from "src/app/types/user";
import { environment } from "src/environments/environment";

/**
 * Enable a logged in user to add various content types to their favorites
 */
@Component({
  selector: "app-favorite-item",
  templateUrl: "./favorite-item.component.html",
  styleUrls: ["./favorite-item.component.scss"],
})
export class FavoriteItemComponent implements OnInit {
  xhrInProgress: boolean = false;
  favorited: boolean = false;
  cordova: boolean = false;
  isBrowser: boolean = false;
  lookupReferer: string;
  user: UserInterface;

  @Input() title: string;
  @Input() slug: string;

  constructor(
    private platform: Platform,
    private authService: AuthService,
    private API: ApiService,
    @Inject(PLATFORM_ID) platformId: string
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    this.platform.ready().then(() => {
      this.cordova = this.platform.is("cordova");
    });

    this.authService.dataChange.subscribe((user) => {
      if (this.isBrowser && !this.cordova) {
        this.user = user;
      }
    });
  }

  /**
   * Toggle favorite depending on content
   */
  toggleFavorite() {
    this.xhrInProgress = true;

    this.API.PUT("shoppers/tracking/log", {
      action: "favorite",
      title: this.title,
      url: this.lookupReferer,
      context: (!this.favorited).toString(),
      mallId: environment.mall_id,
    }).subscribe({
      next: (response) => {
        this.xhrInProgress = false;
        this.favorited = !this.favorited;
      },
      error: (response) => {
        this.xhrInProgress = false;
      },
    });
  }

  checkUser() {
    this.lookupReferer =
      typeof window !== "undefined"
        ? window.location.href
        : this.platform.is("android")
          ? "android/" + this.slug
          : this.platform.is("ios")
            ? "ios/" + this.slug
            : this.slug;

    this.API.AuthGET(`shoppers/tracking/find/favorite`, null, false, {
      "lookup-referer": this.lookupReferer,
    }).subscribe({
      next: (response) => {
        if (response?.context) {
          this.favorited = response?.context === "true";
        } else {
          this.favorited = false;
        }
      },
      error: () => {
        this.favorited = false;
      },
    });
  }

  ngOnInit() {
    if (this.isBrowser && !this.cordova) {
      setTimeout(() => {
        this.user = this.authService.getUser();
        if (this.user) {
          this.checkUser();
        } else {
          setTimeout(() => {
            this.checkUser();
          }, 600);
        }
      }, 1200);
    }
  }
}
